import React, { PropsWithChildren, ReactNode, useRef } from 'react'

import { bemJoin } from '@app/lib/bem'
import { IconButton, IconButtonProps } from '@app/lib/inputs/IconButton/IconButton'

import './Toolbar.scss'

const b = bemJoin('editor-toolbar')

export const Toolbar = ({ children }: PropsWithChildren<any>) => {
  return <div className={b()}>{children}</div>
}

Toolbar.Group = ({ children }: PropsWithChildren<any>) => {
  return <div className={b('group')}>{children}</div>
}

Toolbar.Button = ({
  icon,
  active,
  ...rest
}: IconButtonProps & { icon: ReactNode; active: boolean }) => {
  return (
    <IconButton
      {...rest}
      ref={useRef<HTMLButtonElement>(null)}
      className={b('button', {
        active
      })}
    >
      {icon}
    </IconButton>
  )
}
